// eslint-disable-next-line
export const MEMOIZE_SET = 'MEMOIZE_SET';
